var _circle, _circle2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6219,
    cy: 23.2797,
    r: 22.3304,
    fill: "url(#paint0_linear_1_16378)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6219,
    cy: 23.2797,
    r: 22.3304,
    fill: "#E6EFF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0963 24.909L28.4174 21.2122C28.1235 19.6151 27.9765 18.8166 27.3959 18.3443C26.8152 17.8721 25.9802 17.8711 24.3112 17.8711H19.826C18.1569 17.8711 17.3229 17.8711 16.7413 18.3443C16.1606 18.8166 16.0136 19.6151 15.7198 21.2122L15.0408 24.909C14.4328 28.2237 14.1278 29.8816 15.0651 30.969C16.0025 32.0584 17.7354 32.0584 21.1991 32.0584H22.938C26.4018 32.0584 28.1346 32.0584 29.072 30.97C30.0094 29.8816 29.7054 28.2237 29.0963 24.91",
    stroke: "#006EC2",
    strokeWidth: 1.52006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0683 21.4187V28.0056M19.5349 25.9789L22.0683 28.5123L24.6018 25.9789M31.1887 21.9254C31.3453 21.8473 31.4872 21.7427 31.6082 21.6163C32.2021 21.0022 32.2021 20.0101 32.2021 18.0259C32.2021 16.0417 32.2021 15.0506 31.6082 14.4345C31.0144 13.8184 30.0598 13.8184 28.1486 13.8184H15.9881C14.0768 13.8184 13.1222 13.8184 12.5284 14.4345C11.9346 15.0506 11.9346 16.0427 11.9346 18.0259C11.9346 20.0091 11.9346 21.0012 12.5284 21.6163C12.65 21.7433 12.7899 21.8463 12.9479 21.9254",
    stroke: "#006EC2",
    strokeWidth: 1.52006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_16378",
    x1: 18.2344,
    y1: -0.680664,
    x2: 44.7344,
    y2: 44.3193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006EC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00345C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.014ebb88aaed586fa6e7362eb3d0a8da.svg";
export { ForwardRef as ReactComponent };